// Import and register all your controllers from the controllers directory
import { application } from "./application"
import VisibilityController from "./visibility_controller"

// Register controllers manually (esbuild bundling approach)
application.register("visibility", VisibilityController)
